import {Component} from 'react'
import VisaoTarefasMesterAmbevCard from './ambev'

import './mester.css'
import PropTypes from 'prop-types'

class VisaoTarefasMesterCard extends Component {
  render () {
    return (
      <div data-testid='card-test-id' style={{height: '100%'}}>
        {<VisaoTarefasMesterAmbevCard
          dataCard={this.props.dataCard}
          refreshCard={this.props.refreshCard}
          redirect={this.props.redirect}
        />}
      </div>
    )
  }
}

VisaoTarefasMesterCard.propTypes ={
  dataCard: PropTypes.object,
  refreshCard: PropTypes.func,
  redirect: PropTypes.func
}

export default VisaoTarefasMesterCard
